import { FC, useMemo, useState } from 'react'
import { Country } from 'api/countries/getCountriesList'
import { DropdownField } from 'components/Forms/DropdownListField/DropdownField/Field'
import { SearchableCountrylist } from './SearchableCountryList/SearchableCountryList'

import styles from './CountryCodeSelectorDropDown.module.scss'
import { usePreferredCountry } from './usePreferredCountry'

interface Props {
  countryList: Country[]
  onCountrySelected: (country: Country) => void
}

export const CountryCodeSelectorDropDown: FC<Props> = ({
  countryList,
  onCountrySelected
}) => {
  const preferredCountry = usePreferredCountry(countryList)
  const [showCountryList, setShowCountryList] = useState(false)
  const [selectedCountry, setSelectedCountry] = useState<Country | undefined>(
    preferredCountry
  )

  const sortedCountryList = useMemo(() => {
    return countryList.sort((a, b) => a.name.localeCompare(b.name))
  }, [countryList])

  const handleSelectedCountry = (country: Country) => {
    setShowCountryList(false)
    setSelectedCountry(country)
    onCountrySelected(country)
  }

  if (!selectedCountry) {
    return null
  }

  return (
    <div className={styles.CountryCodeSelectorDropDown}>
      <DropdownField
        onClick={() => setShowCountryList(!showCountryList)}
        selected={
          <div className={styles.SelectedCountry}>
            <img alt={selectedCountry.name} src={selectedCountry.flagUrl} />
            <div>{`+ ${selectedCountry.countryCode}`}</div>
          </div>
        }
        type="dark"
        isPlaceholder={false}
        rotateArrow={showCountryList}
        customStyle={styles.FieldContainer}
      />
      {showCountryList && (
        <SearchableCountrylist
          countryList={sortedCountryList}
          selectedAlpha2={selectedCountry.alpha2}
          onCountrySelect={(country: Country) => handleSelectedCountry(country)}
        />
      )}
    </div>
  )
}
